const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const Chart = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CHART_REQUEST":
      return { loading: true, error: false, data: [] };
    case "CHART_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default Chart;
